var _a;
import { init } from '@wix/velocycle-core';
import { observable, action, reaction } from 'mobx';
import { configure } from './configure';
export var initState = (_a = init({
    configure: configure,
    observable: observable,
    action: action,
    reaction: reaction,
}), _a.initState), initBind = _a.initBind;
//# sourceMappingURL=index.js.map